import React from 'react';

const GameScreenLayout = ({ children, backgroundColor = '#f97316' }) => {
  return (
    <div style={{
      backgroundColor: backgroundColor,
      borderRadius: '16px',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      overflow: 'hidden',
      flex: 1
    }}>
      {children}
    </div>
  );
};

export default GameScreenLayout;
